import { Amplifier } from './Group/Amplifier';
import { Electronics } from './Group/Electronics';
import { ForceSensor } from './Group/ForceSensor';
import { LinearActuator } from './Group/LinearActuator';
import { MaterialSensor } from './Group/MaterialSensor';
import { MeasuringRoller } from './Group/MeasuringRoller';
import { SteeringFrame } from './Group/SteeringFrame';
import { TelemetrySystem } from './Group/TelemetrySystem';
import { TensionAccessories } from './Group/TensionAccessories';
import { TensionController } from './Group/TensionController';
import { WebGuideAccessories } from './Group/WebGuideAccessories';
import { WebGuideController } from './Group/WebGuideController';
import { Groups, TypeInterface } from './Groups';

export enum Solution {
    TensionControl = 'tension-control',
    WebGuiding = 'web-guiding',
    Telemetry = 'telemetry-systems',
    BeltScale = 'belt-scale',
}

export function getSolutionForType(type: TypeInterface): Solution {
    switch (type) {
        case Amplifier.BasicProduct:
        case Amplifier.ProductGroup:
        case ForceSensor.NominalForce:
        case ForceSensor.Options:
        case ForceSensor.Series:
        case ForceSensor.Size:
        case TensionAccessories.ProductGroup:
        case TensionController.BasicProduct:
        case TensionController.ProductGroup:
            return Solution.TensionControl;

        case LinearActuator.BasicProduct:
        case LinearActuator.ProductGroup:
        case LinearActuator.ProductLine:
        case MaterialSensor.BasicProduct:
        case MaterialSensor.ProductGroup:
        case MaterialSensor.ProductLine:
        case SteeringFrame.BasicProduct:
        case SteeringFrame.ProductGroup:
        case SteeringFrame.ProductLine:
        case WebGuideAccessories.ProductGroup:
        case WebGuideController.BasicProduct:
        case WebGuideController.ProductGroup:
            return Solution.WebGuiding;

        case TelemetrySystem.Machine:
        case TelemetrySystem.Option:
        case TelemetrySystem.ProductGroup:
        case TelemetrySystem.Ui:
            return Solution.Telemetry;

        case MeasuringRoller.Series:
        case MeasuringRoller.Size:
            return Solution.BeltScale;

        case Electronics.ProductGroup:
        case Electronics.BasicProduct:
            return Solution.BeltScale;
    }
}

export function getSolutionForGroup(group: Groups): Solution {
    switch (group) {
        case Groups.Amplifier:
        case Groups.ForceSensor:
        case Groups.TensionAccessories:
        case Groups.TensionController:
            return Solution.TensionControl;

        case Groups.LinearActuator:
        case Groups.MaterialSensor:
        case Groups.SteeringFrame:
        case Groups.WebGuideAccessories:
        case Groups.WebGuideController:
            return Solution.WebGuiding;

        case Groups.TelemetrySystem:
            return Solution.Telemetry;

        case Groups.MeasuringRoller:
            return Solution.BeltScale;

        case Groups.Electronics:
            return Solution.BeltScale;
    }
}

export function getAllSolutions(): Solution[] {
    return Object.values(Solution);
}
